import { ReactNode } from 'react';
import styles from './SectionHeader.module.css';

interface SectionHeaderProps {
    children: ReactNode;
    /** Optional trailing content pinned to the end of the header (e.g. a status icon). */
    end?: ReactNode;
}

/**
 * Section label rendered above an inset IonList, matching the grouped-card
 * layout used across the device and account pages. Pair with the `insetList`
 * class from this component's stylesheet on the following IonList.
 */
const SectionHeader: React.FC<SectionHeaderProps> = ({ children, end }) => (
    <h2 className={styles.header}>
        {children}
        {end && <span className={styles.headerEnd}>{end}</span>}
    </h2>
);

export default SectionHeader;
